<template>
  <div class="wrp3">
    <div class="top clear">
      <h1>Doshii</h1>
    </div>
    <ul class="clear page">
      <li @click="jump('/doshii')">Account Connection</li>
      <li class="active" @click="jump('/delivery')">Delivery Partners Keywords</li>
    </ul>
    <ul class="clear tab">
      <li class="active" @click="newDelivery">New Delivery Partners</li>
    </ul>
    <div class="table-wrp delivery" style="min-width:890px">
      <el-table
          :data="tableData"
          style="width: 100%">
        <el-table-column
          label="Delivery Partners"
          prop="deliveryPartners">
        </el-table-column>
        <el-table-column
          label="Doshii Keywords"
          prop="doshiiKeywords">
        </el-table-column>
        <el-table-column
          label="Operation">
          <template slot-scope="scope">
            <div class="btns clear">
              <button class="btn" @click="editInfo(scope.row)">Edit</button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
        </template>
      </el-table>
      <!--<div class="ros_footerPage">
        <el-pagination
            v-if="!loading"
            class="my_pageSel"
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :current-page.sync="page"
            :total="totalRecord">
        </el-pagination>
      </div>-->
    </div>

    <el-dialog
      :title="type === 'add' ? 'New Delivery Partners' : 'Edit Delivery Partners'"
      :visible.sync="dio"
      :modal-append-to-body="false"
      :show-close="false"
      class="delsmsDio_box"
      :close-on-click-modal="false"
      width="840px"
      center>
        <div class="dio-input-item">
            <h2>Delivery Partners Name</h2>
            <el-input type="text" v-model="name" class="input" maxlength="20" @change="name.replace(/\s+/g,'') === '' ? nameWarn = true : nameWarn = false"
            :class="{'warn': nameWarn}" />
        </div>
        <div class="dio-input-item" style="margin-bottom:65px">
            <h2>Doshii Keywords</h2>
            <h3>Case sensitive</h3>
            <el-input type="text" v-model="keyword" class="input" maxlength="20" @change="keyword.replace(/\s+/g,'') === '' ? keywordWarn = true : keywordWarn = false"
            :class="{'warn': keywordWarn}" />
        </div>
        <div class="foot_box">
            <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
            <el-button @click="add" class="cardConBtn">
              {{type === 'add' ? 'Add' : 'Save'}}
              <i v-if="adding" class="el-icon-loading"
            style="margin-left:5px"></i></el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api/doshii'

export default {
  data () {
    return {
      tableData: [],
      loading: true, // 是否正在加载
      // totalRecord: 0,
      // page: 1,
      // pagesize: 10,

      dio: false,
      type: 'add',
      name: '',
      nameWarn: false,
      keyword: '',
      keywordWarn: false,
      id: null,
      adding: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    editInfo(e) {
      var that = this
      that.dio = true
      that.type = 'edit'
      that.id = e.deliveryId
      that.name = e.deliveryPartners
      that.keyword = e.doshiiKeywords
    },
    cancel() {
        var that = this
        if (that.adding)
          return
        that.dio = false
        that.name = ''
        that.nameWarn = false
        that.keyword = ''
        that.keywordWarn = false
    },
    add () {
        var that = this
        if (that.adding)
          return
        if (that.name.replace(/\s+/g,'') === '')
          that.nameWarn = true
        else
          that.nameWarn = false
        if (that.keyword.replace(/\s+/g,'') === '')
          that.keywordWarn = true
        else
          that.keywordWarn = false
        if (that.name.replace(/\s+/g,'') === '' || that.keyword.replace(/\s+/g,'') === '')
          return
        let params = {
            deliveryPartners: that.name,
            doshiiKeywords: that.keyword
        }
        that.adding = true
        if (that.type === 'add') {
          api.createDeliveryPartners({
            params: params,
            callback: (res) => {
              var that = this
              that.adding = false
              that.cancel()
              if(res.data.code == 0){
                that.getList()
              } else{
                Utils.alert('', res.data.message, 'error')
              }
            }
          })
        } else {
          params.deliveryId = that.id
          api.updateDeliveryPartners({
            params: params,
            callback: (res) => {
              var that = this
              that.adding = false
              that.cancel()
              if(res.data.code == 0){
                that.getList()
              } else{
                Utils.alert('', res.data.message, 'error')
              }
            }
          })
        }
    },
    newDelivery() {
        this.dio = true
        this.type = 'add'
    },
    jump (path) {
        this.$router.push(path)
    },
    getList () {
      const data = {
        pageNum: this.page,
        pageSize: this.pagesize
      }
      api.getDeliveryPartners({
        // params: data, 
        callback: this.lstCallback
      })
    },
    lstCallback (res) {
      var that = this
      that.loading = false
      if(res.data.code == 0){
        this.tableData = res.data.data
        // this.totalRecord = res.data.data.total
      } else{
        that.loading = false
        Utils.alert('', res.data.message, 'error')
      }
    },
    // 搜索关键词，
    keySearch () {
      this.page = 1
      this.getList()
    },
    watchkey() {
      var that = this
      if (that.timeout) {
          clearTimeout(that.timeout)
      }
      that.timeout = setTimeout(() => {
          that.keySearch.call(that, that.key)
      }, 2000) 
    }
  },
}
</script>

<style lang="scss" scoped>
.dio-input-item{
    margin-bottom: 30px;
    h2{
        font-size: 14px;
        font-family: SFProText-Regular, SFProText;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 16px;
        margin-bottom: 10px;
    }
    h3{
        font-size: 12px;
        font-family: SFProText-Regular, SFProText;
        font-weight: 400;
        color: #D0D4E7;
        margin-bottom: 10px;
    }
}
.ros_footerPage{
    display: flex;
    justify-content: center;
}
.wrp3{
  color: #fff;
  padding-bottom: 50px;
  .top{
    width: 100%;
    margin-bottom: 39px;
    h1{
      font-size: 24px;
      font-weight: 600;
      float: left;
      margin-right: 50px;
      font-family: 'PingFangSC-Semibold';
    }
    .search{
      float: right;
      width: 300px;
      border-bottom: 1px solid #fff;
      background-size: 24px 22px;
      background-position: left center;
      background-repeat: no-repeat;
      background-image: url('../../assets/s.png');
      margin-top: -3px;
      input{
        outline: none;
        border: none;
        line-height: 30px;
        font-size: 16px;
        font-family:'PingFangSC-Regular,PingFang SC';
        width: 100%;
        background-color: transparent;
        color: #fff;
        box-sizing: border-box;
        padding-left: 30px;
      }
    }
  }
  .page{
    margin-bottom: 64px;
    li{
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #A4A5AD;
      margin-right: 40px;
      cursor: pointer;
      position: relative;
      float: left;
    }
    .active{
      color: #ffffff;
      &:after{
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        background-color: #E83A90;
        position: absolute;
        left: 0;
        bottom: -13px;
      }
    }
  }
  .tab{
    margin-bottom: 30px;
    li{
      padding: 0 23px;
      height: 60px;
      float: left;
      background-color: transparent;
      font-size: 26px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fff;
      border: 2px solid #fff;
      text-align: center;
      line-height: 58px;
      cursor: pointer;
      box-sizing: border-box;
      margin-right: 30px;
    }
    .active{
      border: 2px solid #ea3796;
      color: #ea3796;
    }
  }
  .table-wrp{
    .btns{
      margin-bottom: 0;
    }
    .btn{
      width: 100px;
      height: 40px;
      background: #151c27;
      border: 1px solid #EA3796;
      outline: none;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #EA3796;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/doshii/delivery.vue